module.exports = __webpack_public_path__ + "img/blue_030.f2c064d5.png";